// theme.js
import {
    createMuiTheme,
    createStyles,
    makeStyles,
} from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";
// import DefaulTheme from "./clearesultPowerAndLight/clearesultPowerAndLight";
import DefaulTheme from "./comed/comed";
import {
    AvenirRomanFont,
    AvenirBookFont,
    AvenirBlackFont,
    ProximaFont,
    ProximaLightFont,
    ProximaBoldFont,
} from "./fonts";

const themeBreakpoints = createMuiTheme({
    breakpoints: {
        values: {
            xs: 300,
            sm: 480,
            md: 600,
            lg: 960,
            xl: 1280,
        },
    },
});
const theme = (customTheme = DefaulTheme) =>
    createMuiTheme({
        palette: {
            primary: {
                // light: will be calculated from palette.primary.main,
                main: customTheme.primaryColor,
                // dark: will be calculated from palette.primary.main,
                // contrastText: will be calculated to contrast with palette.primary.main
            },
            secondary: {
                light: customTheme.primaryColorLighter,
                main: customTheme.primaryColorLight,
                // dark: will be calculated from palette.secondary.main,
                contrastText: customTheme.lighterColor,
            },
        },
        typography: {
            fontFamily: "Avenir",
            fontSize: 14,
            button: {
                textTransform: "none",
            },
        },
        overrides: {
            MuiCssBaseline: {
                "@global": {
                    "@font-face": [
                        AvenirRomanFont,
                        AvenirBookFont,
                        AvenirBlackFont,
                        ProximaFont,
                        ProximaLightFont,
                        ProximaBoldFont,
                    ],
                },
            },
            MuiTypography: {
                root: {
                    overflowWrap: "break-word",
                },
                body1: {
                    fontFamily: "Avenir",
                    fontSize: "16px",
                },
                body2: {
                    fontFamily: "Avenir",
                    fontSize: "14px",
                },
                h4: {
                    fontFamily: "Avenir",
                    fontSize: "25px",
                    fontWeight: "bold",
                    marginTop: "30px",
                },
                h5: {
                    fontFamily: "Avenir",
                    fontSize: "16px",
                    fontWeight: "lighter",
                    color: customTheme.textColorPrimary,
                },
                h6: {
                    fontSize: "16px",
                    marginBottom: "30px",
                },
                subtitle1: {
                    fontSize: "16px",
                    color: customTheme.textColorPrimary,
                    fontWeight: "bold",
                    lineHeight: 1,
                },
                subtitle2: {
                    fontSize: "12px",
                    color: customTheme.textColorSecondary,
                    fontWeight: "lighter",
                },
                overline: {
                    fontSize: "16px",
                    color: customTheme.primaryColor,
                    fontWeight: "bold",
                    textTransform: "none",
                },
                caption: {
                    fontFamily: "Avenir",
                    fontSize: "14px",
                    color: customTheme.redLight,
                    marginLeft: "8px",
                },
                gutterBottom: {
                    marginBottom: "10px",
                },
            },
            MuiStepper: {
                root: {
                    padding: "15px 0px",
                    width: "100%",
                },
            },
            MuiStepConnector: {
                alternativeLabel: {
                    top: 20,
                    left: "calc(-50% + 10px)",
                    right: "calc(50% + 10px)",
                },
                active: {
                    "& $line": {
                        borderColor: customTheme.primaryColorLight,
                    },
                },
                completed: {
                    "& $line": {
                        borderColor: customTheme.primaryColorLight,
                    },
                },
                line: {
                    borderColor: `${customTheme.disabledControlLighter}`,
                    borderTopWidth: 2,
                    borderRadius: 1,
                },
                lineHorizontal: {
                    borderTopWidth: 2,
                },
            },
            MuiSvgIcon: {
                root: {
                    fontSize: "2.1rem",
                    color: customTheme.primaryColor
                },
                fontSizeLarge: {
                    fontSize: "30px",
                },
                colorSecondary: {
                    height: "25px",
                    width: "25px",
                    zIndex: 2,
                },
            },
            MuiStepIcon: {
                root: {
                    color: `${customTheme.lighterColor}`,
                    border: `solid 2px ${customTheme.disabledControlLighter}`,
                    borderRadius: "50%",
                    zIndex: 2,
                    "& $text": {
                        fill: `${customTheme.disabledControlLighter}`,
                        marginTop: "50%",
                    },
                    "&$completed": {
                        borderColor: "transparent",
                        color: customTheme.primaryColorLight,
                        "& $text": {
                            fill: `${customTheme.lighterColor}`,
                            marginTop: "50%",
                        },
                    },
                    "&$active": {
                        borderColor: "transparent",
                        color: customTheme.primaryColorLight,
                        "& $text": {
                            fill: `${customTheme.lighterColor}`,
                            marginTop: "50%",
                        },
                    },
                },
                text: {
                    fill: `${customTheme.lighterColor}`,
                    fontSize: "1.35rem",
                },
            },
            MuiStepLabel: {
                label: {
                    color: `${customTheme.disabledControlLighter}`,
                    fontSize: "11px",
                    fontFamily: "Avenir",
                    "&$active": {
                        color: customTheme.primaryColorLight,
                        fontWeight: "bold",
                    },
                    "&$completed": {
                        color: customTheme.primaryColorLight,
                    },
                    "&$disabled": {
                        color: customTheme.primaryColorLight,
                        border: "none",
                        backgroundColor: "none",
                    },
                    "&$alternativeLabel": {
                        marginTop: "5px",
                    },
                },
                alternativeLabel: {
                    marginTop: "5px",
                },
            },
            MuiFormLabel: {
                root: {
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: customTheme.textColorPrimary,
                    "&$disabled": {
                        color: customTheme.textColorPrimary,
                    },
                    "&$error": {
                        color: customTheme.redLight,
                    },
                    "&$focused": {
                        color: customTheme.textColorPrimary,
                    },
                },
                asterisk: {
                    color: "red",
                },
            },
            MuiFormHelperText: {
                root: {
                    fontSize: "11px",
                },
            },
            MuiInputLabel: {
                shrink: {
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: customTheme.textColorPrimary,

                    [themeBreakpoints.breakpoints.down("xs")]: {
                        transform: "translate(0, -10px) scale(1)",
                    },
                    [themeBreakpoints.breakpoints.between("xs", "sm")]: {
                        transform: "translate(0, -5px) scale(1)",
                    },
                    [themeBreakpoints.breakpoints.up("sm")]: {
                        transform: "translate(0, 1.5px) scale(1)",
                    },
                },
            },
            MuiInputBase: {
                root: {
                    height: "5rem",
                    color: customTheme.textColorPrimary,
                    "&$disabled": {
                        backgroundColor: customTheme.shadowColorLight,
                    },
                },
                input: {
                    fontSize: "16px",
                    fontFamily: "Avenir",
                    fontWeight: "lighter",
                    color: customTheme.textColorPrimary,
                    lineHeight: "18px",
                    border: "0 !important",
                    "&:focus": {
                        boxShadow: "none !important",
                    },
                    input: {
                        "&::placeholder": {
                            fontSize: "16px",
                            color: `${customTheme.placeholderInput} !important`,
                            opacity: 1,
                        },
                        WebkitBoxShadow: `0 0 0 1000px ${customTheme.lighterColor} inset`,
                    },
                },
                multiline: {
                    alignItems: "baseline",
                    minHeight: "10rem",
                    height: "auto"
                }
            },
            MuiInput: {
                root: {
                    color: customTheme.textColorPrimary,
                    border: `0.5px solid ${customTheme.disabledControlLighter}`,
                    padding: "9px 16px",
                    "&$error": {
                        color: customTheme.redLight,
                        border: `1px solid ${customTheme.redLight}`,
                    },
                },
                input: {
                    color: customTheme.textColorPrimary,
                    "&$disabled": {
                        color: customTheme.disabledInput,
                        backgroundColor: customTheme.shadowColorLight,
                        WebkitBoxShadow: `0 0 0 1000px ${customTheme.shadowColorLight} inset`,
                    },
                    "&::placeholder": {
                        fontSize: "16px",
                        color: `${customTheme.placeholderInput} !important`,
                        opacity: 1,
                    },
                    WebkitBoxShadow: `0 0 0 1000px ${customTheme.lighterColor} inset`,
                },
                underline: {
                    "&:after": {
                        borderBottom: "none",
                    },
                    "&:before": {
                        borderBottom: "none",
                    },
                    "&:hover:not($disabled):not($focused):not($error):before": {
                        borderBottom: "none",
                    },
                },
                formControl: {
                    "label + &": {
                        marginTop: "30px",
                    },
                },
            },
            MuiButton: {
                root: {
                    boxShadow: "none",
                    borderRadius: "0px",
                    [themeBreakpoints.breakpoints.down("xs")]: {
                        width: "125px",
                    },
                    [themeBreakpoints.breakpoints.between("xs", "sm")]: {
                        width: "150px",
                    },
                    [themeBreakpoints.breakpoints.between("sm", "md")]: {
                        width: "175px",
                    },
                    [themeBreakpoints.breakpoints.between("md", "lg")]: {
                        width: "190px",
                    },
                    [themeBreakpoints.breakpoints.between("lg", "xl")]: {
                        width: "225px",
                    },
                    [themeBreakpoints.breakpoints.up("xl")]: {
                        width: "250px",
                    },
                    height: "40px",
                    fontSize: "16px",
                    fontWeight: "bold",
                },
                containedPrimary: {
                    color: `${customTheme.lighterColor}`,
                    border: "none",
                    boxShadow: "none",
                    backgroundColor: customTheme.primaryColor,
                    "&:hover": {
                        backgroundColor: customTheme.primaryColorDark,
                        color: `${customTheme.lighterColor}`,
                        border: "none",
                        "@media (hover: none)": {
                            backgroundColor: customTheme.primaryColorDark,
                        },
                        boxShadow: "none",
                    },
                    "&.active": {
                        backgroundColor: customTheme.primaryColorDark,
                        color: `${customTheme.lighterColor}`,
                        border: "none",
                        "@media (hover: none)": {
                            backgroundColor: customTheme.primaryColorDark,
                        },
                        boxShadow: "none",
                    },
                    "&$disabled": {
                        backgroundColor: customTheme.disabledColor,
                        color: `${customTheme.lighterColor}`,
                        border: `0.5px solid ${customTheme.disabledColor}`,
                        boxShadow: "none",
                    },
                },
                containedSecondary: {
                    backgroundColor: `${customTheme.lighterColor}`,
                    color: customTheme.primaryColor,
                    border: `0.8px solid ${customTheme.primaryColor}`,
                    boxShadow: "none",
                    opacity: 1,
                    "&$disabled": {
                        backgroundColor: customTheme.disabledColor,
                        color: `${customTheme.lighterColor}`,
                        border: `0.5px solid ${customTheme.disabledColor}`,
                        boxShadow: "none",
                    },
                    "&:hover": {
                        backgroundColor: `${customTheme.lighterColor}`,
                        border: `0.8px solid ${customTheme.primaryColorDark}`,
                        color: customTheme.primaryColorDark,
                        boxShadow: "none",
                        "@media (hover: none)": {
                            backgroundColor: `${customTheme.lighterColor}`,
                            boxShadow: "none",
                        },
                    },
                },
            },
            MuiCard: {
                root: {
                    marginBottom: "24px",
                },
            },
            MuiCardHeader: {
                root: {
                    paddingBottom: "0px",
                },
                title: {
                    fontWeight: "bold",
                    fontSize: "16px",
                },
            },
            MuiFormControl: {
                root: {
                    marginBottom: "26px",
                },
            },
            MuiPaper: {
                elevation1: {
                    boxShadow: `0px 6px 6px -3px ${fade(
                        customTheme.shadowColorMedium,
                        0.16
                    )}, 0px 10px 14px 1px ${fade(
                        customTheme.shadowColorMedium,
                        0.1
                    )}, 0px 4px 18px 3px ${fade(
                        customTheme.shadowColorMedium,
                        0.1
                    )}`,
                },
                outlined: {
                    border: "none",
                    borderTop: `1px solid ${customTheme.primaryColor}`,
                },
                rounded: {
                    borderRadius: 0,
                }
            },
            MuiGrid: {
                item: {
                    padding: "0 12px 0 0 !important",
                },
            },
            MuiAccordion: {
                root: {
                    boxShadow: "none",
                    border: `1px solid ${customTheme.disabledControlLighter}`,
                    margin: "0",
                    "&$expanded": {
                        zIndex: 0,
                        position: "relative",
                        bottom: 1,
                        marginBottom: "30px",
                        maxHeight: "300px",
                        overflow: "hidden auto",
                        "&:last-child": {
                            marginBottom: "30px",
                        },
                        "&$expanded": {
                            marginBottom: "30px",
                        },
                    },
                },
            },
            MuiAccordionSummary: {
                root: {
                    padding: 0,
                },
                content: {
                    margin: 0,
                },
                expandIcon: {
                    color: customTheme.primaryColor,
                },
            },
            MuiCollapse: {
                wrapper: {
                    paddingLeft: "10px"
                }
            },
            MuiCheckbox: {
                root: {
                    zIndex: 5,
                    position: "sticky",
                    bottom: 1,
                    paddingLeft: "4px !important",
                    "&$checked": {
                        "& svg": {
                            fill: customTheme.primaryColor,
                        },
                    },
                },
            },
            MuiAutocomplete: {
                root: {
                    fontFamily: "Avenir",
                },
                loading: {
                    fontSize: "16px",
                },
                option: {
                    fontSize: "16px",
                },
                clearIndicator: {
                    marginRight: "5px",
                    fontSize: "16px"
                },
                listbox: {
                    width: "100%",
                }
            },
            MuiSelect: {
                root: {
                    fontFamily: "Open Sans",
                    color: customTheme.textColorPrimary,
                    "&$disabled": {
                        color: customTheme.disabledControlLighter,
                    },
                },
                select: {
                    color: customTheme.textColorPrimary,
                    zIndex: 1,
                    boxShadow: "none"
                },
                selectMenu: {
                    color: customTheme.textColorPrimary,
                },
            },
            MuiFormControlLabel: {
                root: {
                    margin: "20px 0 30px -12px",
                },
            },
            MuiPickersCalendarHeader: {
                daysHeader: {
                    dayLabel: {
                        color: "#FF0066",
                    }
                }
            },
            MuiPickersToolbarText: {
                toolbarTxt: {
                    marginTop: 0
                }
            },
            MuiPickersDatePickerRoot: {
                toolbar: {
                    alignItems: "center"
                }
            },
            MuiLinearProgress: {
                root: {
                    borderRadius: 10,
                    margin: 0,
                    padding: 0,
                },
                colorPrimary: {
                    backgroundColor: customTheme.disabledControlLighter,
                },
                barColorPrimary: {
                    backgroundColor: "#DA3732",
                },
                colorSecondary: {
                    backgroundColor: customTheme.disabledControlLighter,
                },
                barColorSecondary: {
                    backgroundColor: "#007E18",
                },
            },
        },
    });

const dragAndDropStyle = (customTheme = DefaulTheme) =>
    createMuiTheme({
        baseStyle: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px",
            marginTop: "20px",
            marginBottom: "16px",
            borderWidth: 2,
            borderRadius: 0,
            borderColor: customTheme.disabledControlLighter,
            borderStyle: "dashed",
            backgroundColor: customTheme.shadowColor,
            color: customTheme.textColorPrimary,
            outline: "none",
            transition: "border .24s ease-in-out",
            cursor: "context-menu",
        },
        activeStyle: {
            borderColor: customTheme.shadowColor,
        },
        acceptStyle: {
            borderColor: "#007E18",
        },
        rejectStyle: {
            borderColor: customTheme.primaryColor,
        },
        browserButton: {
            cursor: "pointer",
            border: `2px solid ${customTheme.shadowColor}`,
            borderRadius: 40,
            borderColor: customTheme.disabledControlLighter,
            backgroundColor: customTheme.shadowColorLight,
            color: customTheme.textColorSecondary,
            fontWeight: "normal",
            padding: 10,
            marginTop: 10,
            marginBottom: 20,
            width: 200,
            fontSize: 16,
            boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.1)"
        },
        fileAccepted: {
            float: "left",
            width: "100%",
            paddingTop: 10,
            paddingBottom: 0,
            paddingLeft: 10,
            paddingRight: 0,
            marginBottom: 10,
            backgroundColor: customTheme.shadowColorLight,
        },
        fileName: {
            fontWeight: "normal",
            margintTop: 0,
            marginBlockStart: 0,
            color: customTheme.textColorPrimary,
        },
        fileSize: {
            fontWeight: "normal",
            margintTop: 0,
            marginBlockStart: 0,
            color: customTheme.textColorSecondary,
        },
        previewLink: {
            cursor: "pointer",
            fontWeight: "bold",
            textDecoration: "none",
            color: customTheme.textColorPrimary,
        },
        span: {
            fontSize: "12px",
            paddingBottom: "10px",
            color: customTheme.textColorSecondary,
        },
        progressValue: {
            color: "#007E18",
        },
        progressError: {
            color: "#DA3732",
        },
        uploadCloudIcon: {
            fontSize: 70,
        },
        errorUploadedIcon: {
            fontSize: 70,
            color: "#DA3732"
        },
        uploadedFileIcon: {
            fontSize: 70,
            color: "#007E18",
        },
        deleteButtonIcon: {
            margin: 0,
            padding: 0,
            border: "none",
            cursor: "pointer",
            color: customTheme.textColorSecondary,
            backgroundColor: customTheme.shadowColorLight,
        }
    });

const thumbStyle = makeStyles(
    createStyles({
        thumbsContainer: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginTop: 16,
        },
        thumb: {
            position: "relative",
            display: "inline-flex",
            borderRadius: 2,
            border: "1px solid #EAEFF2",
            marginBottom: 8,
            marginRight: 8,
            width: 80,
            height: 80,
            padding: 4,
            boxSizing: "border-box",
            float: "left",
            zIndex: 1,
        },
        thumbInner: {
            display: "flex",
            minWidth: 0,
            overflow: "hidden",
            justifyContent: "center",
        },
        img: {
            display: "block",
            width: "auto",
            height: "100%",
        },
        parent: {
            position: "relative"
        },
    }));

export { theme, dragAndDropStyle, thumbStyle };
